import { isDev } from "../Common";

export const saveRecordMsg = "Record Saved Successfully.";

export const updateRecordMsg = "Record Updated Successfully.";

export const failedToUpdateRecordMsg =
  "Record Updation failed. Please try again later.";

export const fileDeletionMsg = "File deleted Successfully.";

export const DATE_DISPLAY_FORMAT = "DD-MMM-YYYY";

export const DB_DATE_DISPLAY_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const EXCEL_DATE_TIME_FILENAME_FORMAT = "_YYYYMMDD_HHmmss";

export const PICTURE_UPLOADED_SUCCESSFULLY = "Picture Uploaded Successfully";

export const NO_DATA_FOUND = "Data Not Available";

export const ApiErrorMsg =
  "Oops! Something went wrong. We're on it. Please try again later.";

export const enableTestData = isDev();
export const enableEncryption = !isDev();
